import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { CloseDialogIcon } from "assets/styles/icons";
import { useProgress } from "context/ProgressProvider";
import { useIsMobile } from "pages/landing";
import { useState } from "react";
import {
  AppPrimaryButton,
  AppSecondaryButton,
  BlackTooltip,
} from "shared/components/AppComponents";
import { columnsListBroker, columnsListLoans } from "shared/helpers/Constants";

export const DialogMultipleLoans = ({
  isOpen,
  setIsOpen,
  rowLoanStatus,
  callback,
  loaderMultiLoans,
  createNewLoan = null,
  handleCreateNew = null,
}) => {
  const isMobile = useIsMobile();
  const [selectedLoan, setSelectedLoan] = useState<any>(null);
  const handleSelect = (value: string) => {
    setSelectedLoan(value);
  };
  const { isBroker } = useProgress();
  const isSelected = (value: string) => selectedLoan?.id === value;
  const columnListDetails = isBroker ? columnsListBroker : columnsListLoans;

  return (
    <Dialog
      open={isOpen !== null}
      fullWidth
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "720px",
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h2">Select applications</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        {rowLoanStatus && rowLoanStatus.length === 0 && (
          <Box sx={{ p: 3, textAlign: "center" }}>
            <p>No loan applications found.</p>
          </Box>
        )}

        {rowLoanStatus && rowLoanStatus.length > 0 && (
          <TableContainer component={Paper} sx={{ maxHeight: "40vh" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox"></TableCell>
                  {columnListDetails.map((column) => (
                    <TableCell key={column.field}>
                      <strong>{column.headerName}</strong>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rowLoanStatus &&
                  rowLoanStatus.map((row) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow
                        key={row.id}
                        hover
                        onClick={() => handleSelect(row)}
                        selected={isItemSelected}
                        sx={{ cursor: "pointer" }}
                      >
                        <TableCell padding="checkbox">
                          <Radio
                            checked={isItemSelected}
                            value={row.id}
                            name="loan-selection"
                          />
                        </TableCell>
                        {columnListDetails.map((column) => (
                          <TableCell key={column.field}>
                            {column.field === "email"
                              ? (() => {
                                  const email = row[column.field];
                                  if (email && email.length > 25) {
                                    const atIndex = email.indexOf("@");
                                    if (atIndex > 0) {
                                      const localPart = email.substring(
                                        0,
                                        atIndex,
                                      );
                                      const domain = email.substring(atIndex);
                                      const truncatedLocal =
                                        localPart.substring(0, 10);
                                      const truncatedEmail = `${truncatedLocal}...${domain}`;
                                      return (
                                        <BlackTooltip
                                          title={email}
                                          PopperProps={{
                                            style: { zIndex: 99999 },
                                          }}
                                        >
                                          <span>{truncatedEmail}</span>
                                        </BlackTooltip>
                                      );
                                    }
                                  }
                                  return email;
                                })()
                              : row[column.field]}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions sx={{ gap: "12px" }}>
        {createNewLoan && (
          <AppSecondaryButton
            title={isMobile ? "Create" : "Create New Loan Request"}
            className="btn-small"
            onClick={() => {
              setIsOpen(null);
              handleCreateNew();
            }}
            fullWidth
            disabled={loaderMultiLoans}
          />
        )}

        <AppPrimaryButton
          title="Continue"
          className="btn-small"
          onClick={() => {
            callback(selectedLoan);
          }}
          fullWidth
          isLoading={loaderMultiLoans}
          loadingText="Please wait.."
          disabled={!selectedLoan || loaderMultiLoans}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogMultipleLoans;
